import { z } from 'zod';

import { CustomsLogType, CustomsStateNotificationType, StatusReasonCode, TSDErrorType, TSDWriteOffNotificationStage } from '@e-origin/shared';

export const TSDWriteOffSchema = z
  .object({
    grossMassWrittenOff: z.string().optional().nullable(),
    numberOfPackagesWrittenOff: z.string().optional().nullable(),
    notificationDate: z.date().optional().nullable(),
    notificationStage: z.nativeEnum(TSDWriteOffNotificationStage).optional().nullable(),
    remarks: z.string().optional().nullable(),
    sourceCodes: z.array(z.string()).optional(),
  })
  .optional();

export const TSDFunctionalError = z
  .object({
    sequenceNumber: z.string().optional().nullable(),
    errorPointer: z.string().optional().nullable(),
    errorCode: z.string().optional().nullable(),
    remarks: z.string().optional().nullable(),
    errorReason: z.string().optional().nullable(),
    originalAttributeValue: z.string().optional().nullable(),
    errorType: z.nativeEnum(TSDErrorType).optional().nullable(),
  })
  .optional();

export const TSDCustomsDeclarationRejection = z
  .object({
    businessRejectionType: z.string().optional().nullable(),
    rejectionDate: z.date().optional().nullable(),
    rejectionReason: z.string().optional().nullable(),
  })
  .optional();

export const TSDCustomsLogSchema = z
  .object({
    customsMessageCode: z.string().optional().nullable(),
    parsedAt: z.date().optional().nullable(),
    issuedAt: z.date().optional().nullable(),
    log: z.string().optional().nullable(),
    logFile: z.string().optional().nullable(),
    type: z.nativeEnum(CustomsLogType).optional().nullable(),
  })
  .optional();

export type TSDCustomsLog = z.infer<typeof TSDCustomsLogSchema>;

export const TSDInvalidationRequestSchema = z
  .object({
    invalidationReason: z.string().optional().nullable(),
    invalidationRequestDate: z.date().optional().nullable(),
  })
  .optional();

export const TSDInvalidationDecisionSchema = z
  .object({
    invalidationDecisionDate: z.date().optional().nullable(),
    invalidationInitiatedByCustoms: z.number().optional().nullable(),
  })
  .optional();

export const TSDNotificationsSchema = z
  .object({
    notificationType: z.nativeEnum(CustomsStateNotificationType).optional().nullable(),
    message: z.string().optional().nullable(),
    read: z.boolean().optional().nullable(),
    createdAt: z.date().optional().nullable(),
    _id: z.any().optional(),
  })
  .optional();

export const TSDControlSchema = z.object({
  status: z.string().optional().nullable(),
  type: z.string().optional().nullable(),
  remarks: z.string().optional().nullable(),
  statusReasonCode: z.nativeEnum(StatusReasonCode).optional().nullable(),
  dateAndTime: z.date().optional().nullable(),
});

export const TSDCustomsStateSchema = z
  .object({
    correlationId: z.string().optional().nullable(),
    dateOfAcceptance: z.date().optional().nullable(),
    startOfTemporaryStorage: z.date().optional().nullable(),
    endOfTemporaryStorage: z.date().optional().nullable(),
    businessValidationType: z.string().optional().nullable(),
    customsLogs: z.array(TSDCustomsLogSchema).optional(),
    writeOff: z.array(TSDWriteOffSchema).optional(),
    functionalError: z.array(TSDFunctionalError).optional(),
    customsDeclarationRejection: TSDCustomsDeclarationRejection.optional().nullable(),
    invalidationRequest: TSDInvalidationRequestSchema.optional().nullable(),
    invalidationDecision: TSDInvalidationDecisionSchema.optional().nullable(),
    notifications: z.array(TSDNotificationsSchema).optional(),
    control: TSDControlSchema.optional(),
  })
  .optional();
